import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BaseChartDirective } from 'ng2-charts';

import { ChartComponent } from './chart.component';

/** Replaces NgApexchartsModule wherever <apx-chart> used to be declared. */
@NgModule({
  imports: [CommonModule, BaseChartDirective],
  declarations: [ChartComponent],
  exports: [ChartComponent]
})
export class ChartModule { }
